export const companySet1 = ['5900', '5910', '5950', '5970', '5980'];
export const companySet2 = ['5940', '5960'];
